import {useQuery} from '@tanstack/react-query';
import {useCountryLang} from "./useCountryLang";
import {request} from "../shared/httpInterceptor";
import {useAtom} from "jotai";
import {nextSessionAtom} from "../store/sessionAtom";

export const fetchWishlistById = async (id: number | undefined, countryLang: string | null, session: any, host?: string, cookies?: any) => {
  const res = await request({
    url: `/${countryLang}/wishlist/get/${id}`,
    method: 'get',
    session: session,
    host: host,
    cookies: cookies
  });
  return res.data;
}

export const useWishlistById = (id: number | undefined) => {
  const countryLang = useCountryLang()
  const [sessionAtom] = useAtom(nextSessionAtom)
  const {session, status} = sessionAtom;

  return useQuery(["wishlist", id, countryLang], () => fetchWishlistById(id, countryLang, session), {
    enabled: id!=undefined && countryLang!=null && status=="authenticated",
    keepPreviousData: true
  });
}
